"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABLE_LANDING_LEAD = exports.ParagraphInsertionContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CommentAnchorContext = require("./CommentAnchorContext");
var _insertionLandingsContext = require("./insertion-landings-context");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var TABLE_LANDING_LEAD = exports.TABLE_LANDING_LEAD = "After the table";
var TABLE_CELLS_SEPARATOR = " | ";
var ParagraphInsertionContext = exports.ParagraphInsertionContext = function ParagraphInsertionContext(_ref) {
  var cardId = _ref.cardId,
    precedingParagraphBookmark = _ref.precedingParagraphBookmark,
    precedingParagraphText = _ref.precedingParagraphText;
  var _useContext = (0, _react.useContext)(_insertionLandingsContext.InsertionLandingsContext),
    landingOf = _useContext.landingOf;
  var anchorReading = (0, _CommentAnchorContext.useContextTextReading)(precedingParagraphText, precedingParagraphBookmark, _CommentAnchorContext.readBookmarkedParagraphText);
  var landing = cardId === null ? null : landingOf(cardId, precedingParagraphBookmark);
  if ((landing === null || landing === void 0 ? void 0 : landing.kind) === "paragraph") {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommentAnchorContext.ProposalCardContextLine, {
      lead: "After",
      reading: {
        kind: "known",
        text: landing.text
      },
      unavailablePhrase: _CommentAnchorContext.UNAVAILABLE_PARAGRAPH_PHRASE
    });
  }
  if ((landing === null || landing === void 0 ? void 0 : landing.kind) === "table") {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommentAnchorContext.ProposalCardContextLine, {
      lead: TABLE_LANDING_LEAD,
      reading: {
        kind: "known",
        text: landing.cellTexts.join(TABLE_CELLS_SEPARATOR)
      },
      unavailablePhrase: _CommentAnchorContext.UNAVAILABLE_PARAGRAPH_PHRASE
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommentAnchorContext.ProposalCardContextLine, {
    lead: "After",
    reading: anchorReading,
    unavailablePhrase: _CommentAnchorContext.UNAVAILABLE_PARAGRAPH_PHRASE,
    "data-sentry-element": "ProposalCardContextLine",
    "data-sentry-component": "ParagraphInsertionContext",
    "data-sentry-source-file": "ParagraphInsertionContext.tsx"
  });
};